import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import HttpService from '../../services/httpService';
import { connect } from "react-redux";
import { setSnackInfo } from '../../redux/actions/appAction';


const AlertDialog = (props) => {

  const emailSendToItTeam = async () => {
    try {
      const missingMaterial = { missingMaterial: props.message };
      await HttpService.sendMailToItTeam(missingMaterial);
      props.setSnackInfo("Mail sent successfully!", "success");
    } catch (error) {
      console.error("Error sending mail:", error);
      props.setSnackInfo('Mail not send!', 'error');
    }
  };

  return (
    <>
      <Dialog
        open={props.open}
        onClose={props.onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{
            backgroundColor: '#F47E46',
            fontWeight: 'bold',
            color: 'white',
          }}
        >
          {"List Of Missing Bom Material In ERP"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Typography variant="body1" style={{ whiteSpace: 'pre-line', fontWeight: 'bold', color: "#1C375D" }}>
              {props.message}
            </Typography>
          </DialogContentText>
          <Typography
            variant="body2"
            color="textSecondary"
            style={{
              color: "#355025",
              marginTop: '16px',
            }}
          >
            Note: Please email the missing materials to the Tech Team. Once the materials have been added to the ERP and confirmed, re-upload the BOM file.
          </Typography>
        </DialogContent>
        <DialogActions>
          {/* Send mail button with icon */}
          <Button 
            onClick={emailSendToItTeam} 
            color="primary"
          >
            Send Mail to Tech Team
          </Button>

          <Button onClick={props.onClose} color="secondary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default connect(null, { setSnackInfo })(AlertDialog);